'use client';

import dynamic from 'next/dynamic';

import DotsLoading from '@/components/dots-loading';

const Lottie = dynamic(() => import('lottie-react'), {
  ssr: false,
  loading: () => <DotsLoading />
});

export default Lottie;
